import { TPaginateParams, TResponseTransformer } from '../types'

const paginate = (params: TPaginateParams): TResponseTransformer => {
  return res => {
    const items = JSON.parse(res.body) || []

    const limit = +(params.per_page || 10)
    const offset = +(params.page || 1)
    const results = items.slice((offset - 1) * limit, offset * limit)
    const total_count = items.length

    res.headers.set('x-pagination', JSON.stringify({ has_next: false, total_count }))
    res.body = JSON.stringify(results)
    return res
  }
}

export default paginate
